import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router'

import { routes } from '../../../constants/routes'
import { AdminUsers } from './index'
import { CreateCrmUser } from './CreateCrmUser'

export const SettingsAdminUsersRoutes: FC = () => (
  <Switch>
    <Route path={routes.SETTINGS_ADMIN_USERS} exact component={AdminUsers} />
    <Route path={routes.SETTINGS_ADMIN_USERS_CREATE} exact component={CreateCrmUser} />
    <Redirect to={routes.SETTINGS_ADMIN_USERS} />
  </Switch>
)
